<template>
  <div class="card">
    <h3 class="titleCard" :v-if="title">{{title}}</h3>
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="scss">

.titleCard{
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  color: #93B0AF;
  text-align: center;
  width: 210px;
  height: 24px; 
}

.card{
  width: 234px;
  height: 350px;
  max-height: 368px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 8px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  & .btn-close{
    cursor: pointer;
    top: 7px;
    right: 10px;
  }
}
</style>
